self.fetch||(self.fetch=function(e,n){return n=n||{},new Promise(function(t,s){var r=new XMLHttpRequest,o=[],u=[],i={},a=function(){return{ok:2==(r.status/100|0),statusText:r.statusText,status:r.status,url:r.responseURL,text:function(){return Promise.resolve(r.responseText)},json:function(){return Promise.resolve(JSON.parse(r.responseText))},blob:function(){return Promise.resolve(new Blob([r.response]))},clone:a,headers:{keys:function(){return o},entries:function(){return u},get:function(e){return i[e.toLowerCase()]},has:function(e){return e.toLowerCase()in i}}}};for(var c in r.open(n.method||"get",e,!0),r.onload=function(){r.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(e,n,t){o.push(n=n.toLowerCase()),u.push([n,t]),i[n]=i[n]?i[n]+","+t:t}),t(a())},r.onerror=s,r.withCredentials="include"==n.credentials,n.headers)r.setRequestHeader(c,n.headers[c]);r.send(n.body||null)})});

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


var MAP;
var HOTEL_PIN;
var iconDefault;
var iconHover;
var CONFIG_MAP = {};


(function (){

    if( document.querySelector("body#attractions") !== null ) {
        iconDefault = marker_url;
        iconHover = marker_hover_url;
        let targetAtractions = document.querySelector(".attractions-content__left");

        //SETTINGS
        let categoriesData = [],
            GoogleMapsMarkers = [],
            $GoogleMaps = [];

       
            GOOGLE_MAPS_WRAPPER = document.querySelector("#attractions-map"),
            ATTRACTIONS_CONTENT = document.querySelector(".attractions-content"),
            ATTRACTIONS_WRAPPER = document.querySelector("#attractions-wrapper"),
            LIGHTBOX__FULL_WRAPPER = document.querySelector("#attraction-lightbox"),
            LIGHTBOX__CLOSE_BUTTON = "js-close-lightbox",
            $LIGHTBOX__CLOSE_BUTTON = document.querySelector(`#${LIGHTBOX__CLOSE_BUTTON}`),
            LIGHTBOX_WRAPPER = document.querySelector("#attraction-lightbox__content"),
            CAT_BUTTONS = document.querySelectorAll('.category-button'),
            RESET_BTN = document.getElementById("reset-btn");


        //MARKUP
        function GetAttractionsMarkup(attractions){
            let markup = ``;
            attractions.forEach( attraction => markup += getAttractionMarkUp(attraction) );
            ATTRACTIONS_WRAPPER.innerHTML = markup;
            let getAllAttractionList = document.querySelectorAll("article[data-attraction]");
            getAllAttractionList.forEach( element => element .addEventListener("click", event => OpenLightbox(element) ) );
        }

        function hoverPinHotel(pin, map){

            let nameMarkerOnHover = '<div class="nameMarker"><b>' + CLIENT_NAME + '</b><br>' + SYM_ADDRESS1 + '</div>';

            let infowindow = new google.maps.InfoWindow({
                content: nameMarkerOnHover
            });

            pin.addListener('mouseover', function () {
                infowindow.open(map, pin);
            });

            pin.addListener('mouseout', function () {
                infowindow.close(map, pin);
            });
        };

        function matchAttractionWithMarkers() {

            let tmpGetAttractionFromList = document.querySelectorAll("article[data-attraction]");
            let getAttractionFromList = {};

            tmpGetAttractionFromList.forEach(function (itemAttr) {
                let titleAttrBox = itemAttr.getAttribute('data-name');
                getAttractionFromList[titleAttrBox] = itemAttr;
            });

            GoogleMapsMarkers.forEach(function (itemMarker) {
                let titleMarker = itemMarker.title;
                let nameMarkersOnHover;
                let infowindows;

                if( getAttractionFromList.hasOwnProperty(titleMarker) ) {
                    let attractionBox = getAttractionFromList[titleMarker];
                    var ua = navigator.userAgent, 
                    tablet = /Tablet|iPad/i.test(ua);

                    if(!tablet){
                        attractionBox.addEventListener('mouseover', function () {
                            infowindows = getAttractionHoverMurkup(this, itemMarker, nameMarkersOnHover, infowindows);
                        })
                        attractionBox.addEventListener('mouseout', function () {
                            itemMarker.setIcon(iconDefault);
                            infowindows.close(MAP, itemMarker);
                        })
                    }    
                }
            })
        }

        function getAttractionHoverMurkup(_this, itemMarker, nameMarkersOnHover, infowindows){
            nameMarkersOnHover = '' +
                '<article data-attraction="${id}" class="attraction-hover" data-name="${name}">' +
                '<div class="attraction-hover__wrapper">' +
        
                '<div class="attraction-hover__copy">'+ $( _this ).find( "h2" ).html() +'</div>' +
                '</div>' +
                '</article>';
            infowindows = new google.maps.InfoWindow({
                content: nameMarkersOnHover
            });

            itemMarker.setIcon(iconHover);
            infowindows.open(MAP, itemMarker);
            var latLng = itemMarker.getPosition();
            MAP.setCenter(latLng);

            return infowindows;
        }

        function getAttractionMarkUp(attraction) {
            const {id, name, thumb, description, address, label_learn_more, url,label_visit_website} = attraction;

            let getNameUrlImagethumb = thumb[0].thumbnail.split('/');
            let checkAmountUrl = getNameUrlImagethumb[getNameUrlImagethumb.length - 1];
            let imageAttraction = checkAmountUrl.length > 11 ?  `${thumb[0].thumbnail}` : '';

            let image_markup = "";
            if( imageAttraction )
                image_markup = `<img src="${imageAttraction}" alt="${thumb[0].alt !== 'null' ? thumb[0].alt : 'placeholder image'}">`;

            console.log( attraction );

            let link = url.indexOf('http')<0?site_url+url:url;

            let markup = `<article data-attraction="${id}" class="attraction" data-name="${name}">
                            <div class="attraction__wrapper">
                                <figure class="attraction__image">
                                    ${image_markup}
                                </figure>
                                <div class="attraction__info">
                                    <h2>${name}</h2>
                                    <p>${address}</p>
                                    <p class="description">${description}</p>
                                
                              
                                    ${url && '<a class="pin-website btn-2" href="'+link+'" target="_blank" data-name="'+name+'" data-island="St Kitts">'+label_visit_website+'</a>'}  
                                    <a class="learn-more-btn btn green-bg">${label_learn_more}</a>
                                </div>
                            </div>
                        </article>`;
            return markup;
        }

        function getAttractionMarkUpHover(attraction) {
            const {id, name, thumb, description, address, distance, walking, biking, driving} = attraction;

     
        



            let markup = `<article data-attraction="${id}" class="attraction-hover" data-name="${name}">
                            <div class="attraction-hover__wrapper">
                             
                                <div class="attraction-hover__copy">${name}</div>
                            </div>
                        </article>`;

            return markup;
        }

        //this will appear when the filter does not find any content
        let noContentfilter = `<div class='no-filter-content'>
                                    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 32 32"> <path d="M16 3c-3.472 0-6.737 1.352-9.192 3.808s-3.808 5.72-3.808 9.192c0 3.472 1.352 6.737 3.808 9.192s5.72 3.808 9.192 3.808c3.472 0 6.737-1.352 9.192-3.808s3.808-5.72 3.808-9.192c0-3.472-1.352-6.737-3.808-9.192s-5.72-3.808-9.192-3.808zM16 0v0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM14 22h4v4h-4zM14 6h4v12h-4z"/></svg>
                                    There isn't any content with this filter
                             </div>`;

       //GET INFO
        function GetAttractions(){
            fetch(`${site_url}ajax/functions.php?operation=FrontendLoadAttractionsStkitts` )
                .then((resp) => resp.json() ) // Transform the data into json
                .then( (data) => {

                    //POPULATE GOOGLE MAPS & ATTRACTIONS QUAD 
                    GetAttractionsMarkup(data.pins);
                    LoadGoogleMaps(data.config, data.pins);
                    matchAttractionWithMarkers();

                    setTimeout( ()=>{
                        let currentUrl = window.location.href;
                        if( currentUrl.indexOf( "#b=" ) != "-1" ){
                            let bName = decodeURI( currentUrl.split("#b=")[1] )
                            bName = bName.replaceAll('_', ' ')
                            bName = document.querySelector( "[data-name='"+bName+"'] .learn-more-btn" )

                            const y = bName.getBoundingClientRect().top + window.scrollY;
                            window.scroll({
                                top: y - 600,
                                behavior: 'smooth'
                            });

                            const mouseoverEvent = new MouseEvent('mouseover', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': true
                            });
                            bName.dispatchEvent(mouseoverEvent);
                            bName.parentNode.parentNode.parentNode.style.backgroundColor = "#ECE7E0"
                        }
                    }, 1000 )

                    return categoriesData = data;
                });

        }

        function isValidJson(json) {
            try {
                JSON.parse(json);
                return true;
            } catch (e) {
                return false;
            }
        }

        //GOOGLE MAPS
        function LoadGoogleMaps(config, pins) {

            const InitializeMap = (lat, long, zoom = 13, styles) => {

                //SET POSITION OF MAP
                let PinPosition = new google.maps.LatLng(lat, long); //set longitude and latitude
                let styles_temp = isValidJson( styles ) ? JSON.parse( styles ) : "";

                // option for google map object
                let myOptions = {
                    zoom: zoom,
                    center: PinPosition,
                    mapTypeId: "roadmap",
                    mapTypeControl: false,
                    styles: styles_temp,
                    scrollwheel: false,
                    disableDoubleClickZoom: false,
                    backgroundColor: '#ffffff',
                    panControl: false,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.RIGHT_CENTER
                    }
                };

                // config initial global for map
				CONFIG_MAP = {
					zoomInitial: myOptions.zoom,
					hotel_lat: lat,
					hotel_long: long,
					hotel_position: myOptions.center,
                };

                // create new map make sure a DIV with id myMap exist on page
                MAP = new google.maps.Map(GOOGLE_MAPS_WRAPPER, myOptions), //generate map into div id myMap
                    HOTEL_PIN = {
                        id: "hotel",
                        map: MAP,
                        title: config.hotel_name,
                        icon: config.hotel_pin.pin,
                        zIndex: 2,
                        position: new google.maps.LatLng(config.hotel_pin.lat, config.hotel_pin.long)
                    };
                // create new marker
                new google.maps.Marker(HOTEL_PIN);

                var hotelMaker = new google.maps.Marker(HOTEL_PIN);

                hoverPinHotel(hotelMaker, MAP);

                pins.forEach( pin => {
                    let marker = loadMarker(pin, MAP, config.regular_pin.normal);
                    GoogleMapsMarkers.push(marker);
                    // this shows the name of each pin when hover
                    //hoverPin(marker, MAP);
                } );

                initMapTypeControl(MAP);
                return $GoogleMaps = MAP;
            };

            const { lat, long } = config.hotel_pin,
                { map_zoom, snazzy} = config;

            InitializeMap(lat, long, map_zoom, snazzy);
        }

        // this function accepts two parameters, first: the markers, second: the target map. It shows the name of each pin when hover
        function hoverPin(pin, map){

            let nameMarkerOnHover = '<div class="nameMarker">' + pin.title + '</div>';

            /*let infowindow = new google.maps.InfoWindow({
                content: nameMarkerOnHover
            });*/

            pin.addListener('mouseover', function () {
                infowindow.open(map, pin);
                pin.setIcon(iconHover);
            })

            pin.addListener('mouseout', function () {
                infowindow.close(map, pin);
                pin.setIcon(iconDefault);
            })
        }

        //LOAD MARKER TO MAP
        function loadMarker(pin, map_selector, icon) { 
            let {id, name, lat, long} = pin;

            // create new marker
            let marker = new google.maps.Marker({
                id: id,
                map: map_selector,
                title: name,
                icon: icon,
                zIndex: 1,
                position: new google.maps.LatLng(lat, long)
            });

            let nameMarkerOnHover = getAttractionMarkUpHover(pin);

            let nameMarkerOnHover1 = new google.maps.InfoWindow({
                content: nameMarkerOnHover
            });

            marker.addListener('mouseover', function () {
                nameMarkerOnHover1.open(map_selector, marker);
                marker.setIcon(iconHover);
            })

            marker.addListener('mouseout', function () {
                nameMarkerOnHover1.close(map_selector, marker);
                marker.setIcon(icon);
            })
            marker.addListener('click', event => OpenLightbox(marker) );
            return marker;
        }

        function ExpandContent(event) {
            let el = event.target;
            let getIdBtn = el.getAttribute('id');

            if(getIdBtn === 'js-expand-map'){
                el.textContent = el.textContent === "Expand Map" ? "Contract Map" : "Expand Map";

                if(ATTRACTIONS_CONTENT.classList.contains('map-expanded')){
                    ATTRACTIONS_CONTENT.classList.remove('map-expanded');
                }else{
                    ATTRACTIONS_CONTENT.classList.add('map-expanded');
                }

            }else if(getIdBtn === 'expand--attractions-content'){
                el.textContent = el.textContent === "Expand Attractions" ? "Contract Attractions" : "Expand Attractions";

                if (targetAtractions.style.width !== "100%") {
                    targetAtractions.style.cssText = "width: 100%; z-index: 5";
                    ATTRACTIONS_WRAPPER.classList.add('attractions-expanded');
                } else {
                    targetAtractions.style.removeProperty("width");
                    targetAtractions.style.removeProperty("z-index");
                    ATTRACTIONS_WRAPPER.classList.remove('attractions-expanded');
                }
            }
        }

        function initMapTypeControl(map) {
            if(document.querySelector(".attractions-map__satellite")!==null){
                document.querySelector(".attractions-map__satellite").onclick = function () {
                    document.querySelector(".attractions-map__map").classList.remove('active')
                    this.classList.remove('active')
                    this.classList.add('active')
                    map.setMapTypeId("hybrid");
                };
            }

            if(document.querySelector(".attractions-map__map")!==null){
                document.querySelector(".attractions-map__map").onclick = function () {
                    document.querySelector(".attractions-map__satellite").classList.remove('active')
                    this.classList.remove('active')
                    this.classList.add('active')
                    map.setMapTypeId("roadmap");
                };
            }
        }

        function filterData(filter) {
            let { attraction_categories } = filter;
        
            let result = categoriesData.pins.filter(item => {
                if (attraction_categories !== "" && item.category !== attraction_categories) return false;
                return true;
            });
        
            if (result.length !== 0) {
                GetAttractionsMarkup(result);
            } else {
                document.getElementById('attractions-wrapper').innerHTML = noContentfilter;
            }
        
            GoogleMapsMarkers.forEach(pin => pin.setMap(null));
            GoogleMapsMarkers = [];
            result.forEach(pin => {
                let marker = loadMarker(pin, $GoogleMaps, categoriesData.config.regular_pin.normal);
                GoogleMapsMarkers.push(marker);
                hoverPin(marker);
            });
            matchAttractionWithMarkers();

        }

        //LIGHTBOX
        const LIGHTBOX_OPENED__CLASS = "opened-lightbox";
        function OpenLightbox (element){
            //Get Pin ID and then info
            let pin_id = typeof element.id === "number" ? element.id : parseInt( element.getAttribute("data-attraction") ),
                PinInfo = categoriesData.pins[pin_id];

            //Get Pin Info
            let markup = getAttractionMarkUp(PinInfo);
            LIGHTBOX_WRAPPER.innerHTML = markup;
            document.querySelector("body").style.overflowY = 'hidden';
            LIGHTBOX__FULL_WRAPPER.classList.add(LIGHTBOX_OPENED__CLASS);
        }

        function CloseLigthbox(event) {
            if(event.keyCode === undefined && !event.target.classList.contains( LIGHTBOX_OPENED__CLASS )  && event.target.id !== LIGHTBOX__CLOSE_BUTTON ) return false;
            LIGHTBOX_WRAPPER.innerHTML = "";
            LIGHTBOX__FULL_WRAPPER.classList.remove(LIGHTBOX_OPENED__CLASS);
            document.querySelector("body").style.overflowY = 'visible';
        }

        // FUNCTION CALLING AND EVENT LISTENERS
        GetAttractions();
        document.getElementById("js-expand-map").addEventListener("click", event => ExpandContent(event));
        CAT_BUTTONS.forEach(button => {
            button.addEventListener('click', function() {
                const category = this.getAttribute('data-category')
                // Perform filtering based on the selected category
                filterData({ attraction_categories: category })
                CAT_BUTTONS.forEach(el => el.classList.remove('active'))
                RESET_BTN.classList.remove('active')
                this.classList.add('active')
            });
        });
        RESET_BTN.addEventListener("click", () => {
            filterData({ attraction_categories: '' })
            CAT_BUTTONS.forEach(el => el.classList.remove('active'))
            RESET_BTN.classList.add('active')
        });

        document.addEventListener('keydown', (event) =>  event.keyCode === 27 ? CloseLigthbox(event)  : false  );
        LIGHTBOX__FULL_WRAPPER.addEventListener('click', (event) =>  CloseLigthbox(event) );
        $LIGHTBOX__CLOSE_BUTTON.addEventListener('click', (event) =>  CloseLigthbox(event) );
    }
})();
